'use client';

import { useSyncExternalStore } from 'react';
import { getThemeServerSnapshot, getThemeSnapshot, subscribeTheme } from './theme.store';
import type { ThemeMode } from './theme.constants';

export function useTheme(): ThemeMode {
    return useSyncExternalStore(subscribeTheme, getThemeSnapshot, getThemeServerSnapshot);
}
